import { render } from "./SummaryCustomerSection.vue?vue&type=template&id=3febaa56"
import script from "./SummaryCustomerSection.vue?vue&type=script&lang=js"
export * from "./SummaryCustomerSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__